import { TextField } from "@mui/material";
import { IEvent, IEventScoreBoardResult } from "bets.oddprovider.lib.common.ts/models";
import React from "react";

export type EventScoreBoardResultComponentProps = {
  result: IEventScoreBoardResult,
  event: IEvent,
  onChangeResult?: (result: IEventScoreBoardResult) => void
}

export const EventScoreBoardResultComponent: React.FC<EventScoreBoardResultComponentProps> = ({
  result, event, onChangeResult,
}) => {
  const caption = event.participants[result.position - 1].name
  return <>
    <TextField
      value={result.value}
      label={caption}
      onChange={e => {
        result.value = e.target.value
        onChangeResult?.(result)
      }}
      fullWidth
      sx={{
        width: { xs: 'calc(50% - 10px)', sm: 'calc(33.33% - 13.33px)' },
        flexGrow: 1,
      }}
    />

  </>
}